module.exports = __webpack_public_path__ + "img/1.a4411e76.png";